import { Component, inject, Input, TemplateRef, ViewChild, signal } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserAttestation } from 'src/app/service/global.service';
import { TranslationService } from 'src/app/service/translation.service';
import {MatDividerModule} from '@angular/material/divider';
import { LoadingErrorComponent } from 'src/app/components/loading-error/loading-error.component';
import { CommonsModalPartComponent } from 'src/app/attestations/commons-modal-part/commons-modal-part';

@Component({
  selector: 'app-modal-browser-attestations',
  templateUrl: './modal-browser-attestations.component.html',
  styleUrls: ['./modal-browser-attestations.component.scss'],
  providers: [NgbModalConfig, NgbModal, TranslationService],
  imports: [TranslateModule, MatDividerModule, LoadingErrorComponent, CommonsModalPartComponent],
  standalone: true
})
export class ModalBrowserAttestationsComponent {

  @Input() browserAttestation?: BrowserAttestation;
  @Input() modalRef?: string;

  @ViewChild('browser') browserRef!: TemplateRef<any>;
  @ViewChild('system') systemRef!: TemplateRef<any>;

  readonly translationService = inject(TranslationService);

  isListOpen = signal(false);
  listTitle = signal('');
  listObject = signal<string[]>([]);

  constructor(config: NgbModalConfig, private readonly modalService: NgbModal) {
   
    config.backdrop = 'static';
    config.keyboard = false;
  }


  open(): void {
    if (this.modalRef === 'browser') {
      this.modalService.open(this.browserRef, { size: 'xl' });
    } else if (this.modalRef === 'system') {
      this.modalService.open(this.systemRef, { size: 'xl' });
    }
  }

  openList(type: string) {
    this.isListOpen.set(true);
    this.translationService.get('browser-attestations-details-modal-list-' + type + '-title')
      .subscribe(title => {
        this.listTitle.set(title);
      });
  }

  back() {
    this.isListOpen.set(false);
    this.listObject.set([]);
    this.listTitle.set('');
  }

  getPluginsList() {
    const plugins = this.browserAttestation?.components?.plugins?.map(plugin => plugin.name) ?? [];
    this.listObject.set(plugins);
    this.openList('plugins');
  }

  getFontsList() {
    this.listObject.set(this.browserAttestation?.components?.fonts ?? []);
    this.openList('fonts');
  }

  getLanguagesList() {
    this.listObject.set(this.browserAttestation?.components?.languages ?? []);
    this.openList('languages');
  }

  getFontsPreferencesList() {
    const prefs = Object.entries(this.browserAttestation?.components?.fontPreferences ?? {})
      .map(([key, value]) => `${key}: ${value}`);
    this.listObject.set(prefs);
    this.openList('fonts-preferences');
  }
}
